/*
  HeyCuida · lm-pack-selector.js (v8-hc, 11/10/2026)
  Tarjetas de pack y regalos del bloque lm_pack_selector (snippets/lm-pack-selector.liquid y hc-regalos-ficha.liquid).
  Producto de una sola variante: el pack es la cantidad de esa variante (1, 2 o 3). Sin colores ni versiones.

  Integración con el tema (Zendrop 3.0.0 / Dawn):
  - Compra: se intercepta el «submit» del formulario del tema (#product-form-SECCION) en fase de captura, en document,
    antes que el listener de assets/product-form.js (que está en el propio formulario). Se añade la variante única con
    quantity = uds del pack (POST cart/add.js { items }) y después se hace lo mismo que el tema: botón en «loading»,
    publish(cartUpdate), cart.renderContents(respuesta) (abre el cajón) y errores en el mensaje del propio formulario.
    Además se refresca el contador del icono (sección cart-icon-bubble). El formulario se reconoce con
    form.getAttribute('id'): form.id devolvería el <input name="id"> del formulario, no su id.
  - Sin JS el bloque no se ve (no-js-hidden) y el formulario del tema añade 1 unidad: la compra no se rompe.
  - Al montarse, el componente pone data-lm-pack-ready. Si este archivo no carga o falla, el snippet lo nota en
    DOMContentLoaded (sin esa marca), pone html.lm-pack-off y oculta el selector.
  - Importes: los pinta el Liquid con money. Aquí solo se formatea el aviso para lectores de pantalla, con
    window.HC.moneyFormat (o shop.money_format del propio bloque), nunca con un símbolo escrito a mano.
  Espacio de nombres: lm-pack / data-lm-pack-*. Sin librerías.
  La lógica pura (LmPackLogic) se exporta también para Node (pruebas locales, no se suben al tema).
*/
(function () {
  'use strict';

  /* ================= Lógica pura (sin DOM) ================= */

  var Logic = (function () {
    function toInt(value, fallback) {
      var n = parseInt(value, 10);
      return isNaN(n) ? fallback : n;
    }

    // Por unidad: redondeo al céntimo más cercano (mitad hacia arriba) con enteros, igual que el Liquid.
    function perUnit(total, qty) {
      var q = Math.max(1, toInt(qty, 1));
      var t = Math.max(0, toInt(total, 0));
      return Math.floor((2 * t + q) / (2 * q));
    }

    // Descuento del pack con los importes de HC (desc2 con 2 uds, desc3 con 3 o más), como el Liquid.
    function packDiscount(qty, desc2, desc3) {
      var q = toInt(qty, 1);
      if (q >= 3) return Math.max(0, toInt(desc3, 0));
      if (q === 2) return Math.max(0, toInt(desc2, 0));
      return 0;
    }

    function giftIncluded(qty, minQty) {
      return toInt(qty, 0) >= Math.max(1, toInt(minQty, 1));
    }

    function uniqueSections(ids, max) {
      var out = [];
      (Array.isArray(ids) ? ids : []).forEach(function (id) {
        if (id && out.indexOf(id) === -1) out.push(id);
      });
      return out.slice(0, max || 5);
    }

    // Formato clásico de Shopify (shop.money_format). Contempla {{amount_with_comma_separator}} y {{amount}}.
    function formatMoney(cents, format) {
      var fmt = typeof format === 'string' && format ? format : '{{amount}}';
      var re = /\{\{\s*(\w+)\s*\}\}/;
      var n = toInt(cents, 0);

      function withDelimiters(number, precision, thousands, decimal) {
        var negative = number < 0;
        var fixed = (Math.abs(number) / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var result = whole + (parts[1] ? decimal + parts[1] : '');
        return (negative ? '-' : '') + result;
      }

      var match = fmt.match(re);
      var value;
      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          value = withDelimiters(n, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(n, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(n, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(n, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(n, 0, ' ', ',');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(n, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = withDelimiters(n, 2, ' ', '.');
          break;
        default:
          value = withDelimiters(n, 2, ',', '.');
      }
      return match ? fmt.replace(re, value) : value;
    }

    // Una sola línea: la variante única con la cantidad del pack. extra: { properties, selling_plan }.
    function buildItems(variantId, qty, extra) {
      var id = toInt(variantId, 0);
      var q = Math.max(1, toInt(qty, 1));
      if (!id) return [];
      var item = { id: id, quantity: q };
      if (extra && typeof extra === 'object') {
        if (extra.properties && typeof extra.properties === 'object') item.properties = extra.properties;
        if (extra.selling_plan) item.selling_plan = extra.selling_plan;
      }
      return [item];
    }

    function buildBody(items, sections, sectionsUrl) {
      var body = { items: items };
      if (Array.isArray(sections) && sections.length) {
        body.sections = sections;
        body.sections_url = sectionsUrl || '/';
      }
      return body;
    }

    return {
      toInt: toInt,
      perUnit: perUnit,
      packDiscount: packDiscount,
      giftIncluded: giftIncluded,
      uniqueSections: uniqueSections,
      formatMoney: formatMoney,
      buildItems: buildItems,
      buildBody: buildBody,
    };
  })();

  if (typeof module === 'object' && module && module.exports) module.exports = Logic;
  if (typeof window === 'undefined' || !window.customElements || typeof window.HTMLElement !== 'function') return;
  window.LmPackLogic = Logic;
  if (window.customElements.get('lm-pack-selector')) return;

  /* ================= Componente ================= */

  var toInt = Logic.toInt;
  var decoder = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  // El formato de la tienda puede traer HTML (<span class=money>) o entidades: se deja solo el texto.
  function plainText(str) {
    var s = String(str === null || str === undefined ? '' : str).replace(/<[^>]*>/g, '');
    if (s.indexOf('&') === -1) return s;
    decoder = decoder || document.createElement('textarea');
    decoder.innerHTML = s;
    return decoder.value;
  }

  function publishEvent(name, data) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[name]) {
        publish(PUB_SUB_EVENTS[name], data);
      }
    } catch (error) {
      /* pubsub del tema no disponible: no bloquea la compra */
    }
  }

  function sectionInner(html, selector) {
    if (typeof html !== 'string' || !html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  class LmPackSelector extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      var dataEl = this.querySelector('script[data-lm-pack-data]');
      if (!dataEl) return;
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (error) {
        this.data = null;
        return;
      }

      var data = this.data;
      var self = this;
      this.sectionId = this.dataset.section;
      this.formId = 'product-form-' + this.sectionId;
      this.labels = data.labels && typeof data.labels === 'object' ? data.labels : {};
      this.packs = {};
      (Array.isArray(data.packs) ? data.packs : []).forEach(function (pack) {
        if (pack && pack.n) {
          self.packs[toInt(pack.n, 0)] = { qty: Math.max(1, toInt(pack.qty, 1)), price: toInt(pack.price, 0) };
        }
      });

      this.cards = toArray(this.querySelectorAll('[data-lm-pack-card]'));
      this.gifts = toArray(this.querySelectorAll('[data-lm-pack-gift]'));
      this.status = this.querySelector('[data-lm-pack-status]');

      var checked = this.querySelector('[data-lm-pack-radio]:checked');
      this.selected = checked ? toInt(checked.value, 0) : toInt(data.selected, 0);
      if (!this.packs[this.selected]) this.selected = toInt(data.selected, 0);

      this.lastSelected = undefined;
      this.addEventListener('change', this.onChange);
      document.addEventListener('submit', this.onSubmit, true);

      this.render(false);

      // Listo: sin esta marca al llegar DOMContentLoaded el snippet pone html.lm-pack-off y oculta el selector.
      // Si se monta tarde (editor del tema), se recupera.
      this.setAttribute('data-lm-pack-ready', '');
      document.documentElement.classList.remove('lm-pack-off');
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('submit', this.onSubmit, true);
    }

    qtyOf(n) {
      var pack = this.packs[n];
      return pack ? pack.qty : 1;
    }

    money(cents) {
      var fmt = (window.HC && window.HC.moneyFormat) || (this.data && this.data.moneyFormat);
      return plainText(Logic.formatMoney(cents, fmt));
    }

    /* ---------- Elección de pack ---------- */

    onChange(event) {
      var target = event.target;
      if (!target || target.type !== 'radio' || !target.hasAttribute('data-lm-pack-radio')) return;
      if (target.closest('lm-pack-selector') !== this) return;
      var n = toInt(target.value, 0);
      if (!this.packs[n]) return;
      this.selected = n;
      this.render(true);
    }

    render(announce) {
      var self = this;
      var qty = this.qtyOf(this.selected);
      var selectedCard = null;

      this.cards.forEach(function (card) {
        var isSelected = toInt(card.getAttribute('data-pack'), 0) === self.selected;
        card.classList.toggle('is-selected', isSelected);
        var radio = card.querySelector('[data-lm-pack-radio]');
        if (radio && radio.checked !== isSelected) radio.checked = isSelected;
        if (isSelected) selectedCard = card;
      });

      var unlocked = 0;
      this.gifts.forEach(function (gift) {
        var included = Logic.giftIncluded(qty, gift.getAttribute('data-min'));
        if (included) unlocked += 1;
        gift.classList.toggle('is-locked', !included);
        var free = gift.querySelector('[data-lm-pack-gift-free]');
        var locked = gift.querySelector('[data-lm-pack-gift-locked]');
        if (free) free.hidden = !included;
        if (locked) locked.hidden = included;
      });

      if (announce) this.announce(selectedCard, unlocked);

      if (this.selected !== this.lastSelected) {
        this.lastSelected = this.selected;
        this.dispatchEvent(
          new CustomEvent('lm:pack-change', {
            bubbles: true,
            detail: { sectionId: this.sectionId, pack: this.selected, qty: qty },
          })
        );
      }
    }

    // Al cambiar de pack: nombre, precio y regalos incluidos para lectores de pantalla.
    announce(card, unlocked) {
      if (!this.status || !card) return;
      var pack = this.packs[this.selected];
      var title = card.querySelector('[data-lm-pack-title]');
      var prefix = title ? title.querySelector('[aria-hidden="true"]') : null;
      var name = title ? title.textContent.replace(prefix ? prefix.textContent : '', '').replace(/\s+/g, ' ').trim() : '';
      var text = (name ? name + ': ' : '') + (pack ? this.money(pack.price) : '');
      if (this.gifts.length) text += ' · 🎁 ' + unlocked + '/' + this.gifts.length;
      this.status.textContent = text;
    }

    /* ---------- Compra ---------- */

    variantId(form) {
      var input = form && form.querySelector('input[name="id"]');
      var id = input ? toInt(input.value, 0) : 0;
      return id || toInt(this.data && this.data.variantId, 0);
    }

    formExtras(form) {
      var extra = {};
      var props = null;
      try {
        new FormData(form).forEach(function (value, key) {
          if (typeof value !== 'string') return;
          var match = /^properties\[(.+)\]$/.exec(key);
          if (match && value !== '') {
            props = props || {};
            props[match[1]] = value;
          } else if (key === 'selling_plan' && value) {
            extra.selling_plan = value;
          }
        });
      } catch (error) {
        /* sin FormData: el pack va sin propiedades */
      }
      if (props) extra.properties = props;
      return extra;
    }

    onSubmit(event) {
      var form = event.target;
      // getAttribute: el formulario lleva un <input name="id"> y form.id devolvería ese campo, no el id del formulario.
      if (!form || !form.getAttribute || form.getAttribute('id') !== this.formId || !this.isConnected || !this.data) return;
      var pack = this.packs[this.selected];
      var items = pack ? Logic.buildItems(this.variantId(form), pack.qty, this.formExtras(form)) : [];
      if (!items.length) return; // sin datos: el tema añade 1 unidad como siempre

      event.preventDefault();
      event.stopPropagation(); // el listener de product-form.js (en el formulario) no llega a ejecutarse
      this.addPack(form, items);
    }

    addPack(form, items) {
      var self = this;
      var productForm = form.closest('product-form');
      var button = (productForm && productForm.submitButton) || form.querySelector('[type="submit"]');
      if (button && (button.getAttribute('aria-disabled') === 'true' || button.disabled)) return;

      var showError = function (message) {
        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(message || false);
        } else if (message) {
          console.warn(message);
        }
      };

      showError(false);
      if (this.data.available === false) {
        showError(this.labels.unavailable || (window.variantStrings && window.variantStrings.unavailable));
        return;
      }

      var cart = (productForm && productForm.cart) || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var spinner = (productForm || form).querySelector('.loading__spinner');
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var sections = [];
      if (cart) {
        if (typeof cart.getSectionsToRender === 'function') {
          // Igual que product-form.js: los ids de getSectionsToRender() (renderContents los busca por id).
          sections = cart.getSectionsToRender().map(function (section) { return section.id; });
        }
        if (document.getElementById('cart-icon-bubble')) sections.push('cart-icon-bubble');
        sections = Logic.uniqueSections(sections, 5);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var body = Logic.buildBody(items, sections, window.location.pathname);
      var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data || data.status) {
            publishEvent('cartError', {
              source: 'product-form',
              productVariantId: items[0].id,
              errors: data && (data.errors || data.description),
              message: data && data.message,
            });
            showError((data && (data.description || data.message)) || self.labels.error);
            // 422 por stock: Shopify puede haber añadido parte. Se refrescan cajón y contador sin abrir nada.
            if (cart && data && data.status === 422) self.refreshCartQuietly(cart);
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          publishEvent('cartUpdate', { source: 'product-form', productVariantId: items[0].id, cartData: data });
          self.renderCart(cart, data);
        })
        .catch(function (error) {
          console.error(error);
          showError(self.labels.error);
        })
        .finally(function () {
          if (button) {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    }

    renderCart(cart, data) {
      var state = data;
      // La notificación de Dawn espera una línea (key) con sus secciones; el cajón, el objeto tal cual.
      if (cart.tagName && cart.tagName.toLowerCase() === 'cart-notification' && data.items && data.items[0]) {
        state = Object.assign({}, data.items[0], { sections: data.sections });
      }
      try {
        cart.renderContents(state);
      } catch (error) {
        console.error(error);
        window.location = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      this.updateBubble(data.sections && data.sections['cart-icon-bubble']);
    }

    updateBubble(html) {
      var bubble = document.getElementById('cart-icon-bubble');
      var inner = sectionInner(html, '.shopify-section');
      if (bubble && inner !== null) bubble.innerHTML = inner;
    }

    refreshCartQuietly(cart) {
      var self = this;
      if (!cart || cart.tagName.toLowerCase() !== 'cart-drawer' || typeof cart.getSectionsToRender !== 'function') return;
      var url = ((window.routes && window.routes.cart_url) || '/cart') + '?sections=cart-drawer,cart-icon-bubble';
      fetch(url)
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          var html = sections && sections['cart-drawer'];
          if (typeof html !== 'string') return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          cart.getSectionsToRender().forEach(function (section) {
            if (!section.selector) return;
            var target = document.querySelector(section.selector);
            var source = doc.querySelector(section.selector);
            if (target && source) target.innerHTML = source.innerHTML;
          });
          var drawer = doc.querySelector('cart-drawer');
          if (drawer) cart.classList.toggle('is-empty', drawer.classList.contains('is-empty'));
          self.updateBubble(sections['cart-icon-bubble']);
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  }

  window.customElements.define('lm-pack-selector', LmPackSelector);
})();
